import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const notificationService = {
  async getAllAsync(params) {
    const response = await apiClient.get(endPoints.notification.getAll, {
      params: params,
    });
    return response.data;
  },

  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.notification.getAllSearch, {
      params: params,
      signal: signal,
    });
    return response.data;
  },

  async getDetail(id) {
    const response = await apiClient.get(
      `${endPoints.notification.getDetail}/${id}`
    );
    return response.data;
  },

  async edit(id) {
    const response = await apiClient.get(
      `${endPoints.notification.edit}/${id}`
    );
    return response.data;
  },

  async create(data) {
    const response = await apiClient.post(endPoints.notification.create, data);
    return response.data;
  },

  async update(id, data) {
    const response = await apiClient.post(
      `${endPoints.notification.update}/${id}`,
      data
    );
    return response.data;
  },

};
